import { logClientEvent } from "@bodhistreams/utils";
import { QueryClient } from "@tanstack/react-query";

/**
 * React Query Client Configuration
 *
 * This is the centralized query client instance for the BodhiStreams application.
 * It provides sensible defaults for caching and error handling.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Cache data for 5 minutes by default
			staleTime: 5 * 60 * 1000,
			// Keep data in cache for 30 minutes after becoming unused
			gcTime: 30 * 60 * 1000,
			// Retry failed requests 3 times with exponential backoff
			retry: 3,
			// Don't refetch on window focus by default (can be overridden per query)
			refetchOnWindowFocus: false,
			// Don't refetch on reconnect by default (can be overridden per query)
			refetchOnReconnect: false,
			// Don't refetch on mount if data is fresh (can be overridden per query)
			refetchOnMount: true,
		},
		mutations: {
			// Retry failed mutations once
			retry: 1,
			// Show loading states for mutations
			onError: (error) => {
				console.error("Mutation error:", error);
				// Mutations that fail after retries — ship to backend telemetry.
				logClientEvent({
					kind: "query_error",
					level: "error",
					message: error?.message || "mutation error",
					stack: error?.stack || "",
				});
			},
		},
	},
});
